import { z } from 'zod'
import { AccountStatus } from '~/enums/account-status-code'
import { TrueFalse } from '~/enums/true-false'

/**
 * 帳號 - 新增 Request Schema
 */
export const createAccountRequestSchema = z.object({
  /** 帳號 */
  accountNo: z.string().optional(),
  /** 生日 */
  birthday: z.string().nullable().optional(),
  /** 公司/部門 */
  companyDept: z.string().nullable().optional(),
  /** 帳號建立者 */
  createUser: z.string().nullable().optional(),
  /** Email */
  eMail: z.string(),
  /** 是否啟用 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 職稱 */
  jobTitle: z.string().nullable().optional(),
  /** 異動者 */
  modifyUser: z.string().optional(),
  /** 異動日期 */
  modifyDate: z.string().optional(),
  /** 顯示名稱 */
  nickName: z.string().optional(),
  /** 密碼 */
  password: z.string(),
  /** 聯絡手機 */
  phone: z.string().nullable().optional(),
  /** 顯示個人圖檔 */
  picture: z
    .union([z.string(), z.instanceof(File)])
    .nullable()
    .optional(),
  /** 真實姓名 */
  realName: z.string(),
  /** 角色 */
  role: z.array(z.string()).nullable().optional(),
  /** 審核狀態代碼 */
  statusCode: z.nativeEnum(AccountStatus).nullable().optional(),
  /** 聯絡電話 */
  tel: z.string().nullable().optional(),
  /** 是否為前台註冊 */
  frontRegister: z.nativeEnum(TrueFalse).optional(),
  /** 角色類型 */
  roleClass: z.string().optional(),
  /** 所屬單位處長 */
  director: z.string().nullable().optional()
})

/**
 * 帳號 - 新增 Request
 */
export interface CreateAccountRequest
  extends z.infer<typeof createAccountRequestSchema> {}
